import { TextField } from '@fs/zion-ui'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { isAlphaNumericPersonId } from '../../util/EntityUtil'
import { getPersonName } from '../../services/personService'
import useNotifications from '../../hooks/useNotifications'

export default function DmcVerifiedPersonIdTextField({
  value,
  onChange,
  setIsVerifiedPerson,
  label,
  placeholder,
  onBlur,
  verifyOnRender = false,
}) {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const [waitingForVerification, setWaitingForVerification] = useState(false)
  const [verifiedPersonName, setVerifiedPersonName] = useState()
  const [readyToVerify, setReadyToVerify] = useState(verifyOnRender)

  const getValidMessage = () => {
    if (isAlphaNumericPersonId(value)) {
      if (verifiedPersonName) {
        return verifiedPersonName
      }
      if (readyToVerify) {
        return t('person.validPersonId', 'Valid Person ID')
      }
    }
    return null
  }

  const getErrorMessage = () => {
    if (waitingForVerification) {
      return null
    }
    if (!value) {
      return null
    }
    if (!isAlphaNumericPersonId(value)) {
      return t('person.invalidPersonId', 'Invalid Person ID')
    }
    if (verifiedPersonName === 'Not Found' && readyToVerify) {
      return t('person.personNotFound', 'Person not found')
    }
    return null
  }

  const onInputChange = (e) => {
    if (!waitingForVerification) {
      onChange(e)
      setVerifiedPersonName()
      setIsVerifiedPerson(!e.target.value)
      setReadyToVerify(true)
    }
  }

  useEffect(() => {
    const getPersonAsync = async () => {
      try {
        setWaitingForVerification(true)
        const personName = await getPersonName(value.toUpperCase())
        setWaitingForVerification(false)
        setVerifiedPersonName(personName)
        setIsVerifiedPerson(personName !== 'Not Found')
      } catch (err) {
        setWaitingForVerification(false)
        setIsVerifiedPerson(false)
        setVerifiedPersonName('Not Found')
        error(`Error verifying person: ${err.message || ''}`, err)
      }
    }
    if (isAlphaNumericPersonId(value) && !verifiedPersonName && readyToVerify) {
      getPersonAsync()
    }
  }, [error, setIsVerifiedPerson, value, verifiedPersonName, readyToVerify])

  return (
    <TextField
      id="DmcVerifiedPersonIdTextField"
      label={label}
      placeholder={placeholder}
      type="text"
      value={value}
      onChange={onInputChange}
      onBlur={onBlur}
      validMessage={getValidMessage()}
      errorMessage={getErrorMessage()}
    />
  )
}
